import React, { useEffect, useRef } from 'react';

export const RequestProject = ({ onBack }) => {
  const formRef = useRef(null);

  useEffect(() => {
    const script = document.createElement('script');
    script.src = '//js.hsforms.net/forms/embed/v2.js';
    script.charset = 'utf-8';
    script.addEventListener('load', () => {
      if (window.hbspt && formRef.current) {
        window.hbspt.forms.create({
          portalId: '5387692',
          formId: '4cfd8045-1638-4279-bc63-d89aea24d90c',
          region: 'na1',
          target: '#hubspot-request-form'
        });
      }
    });
    document.body.appendChild(script);

    return () => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div style={{ minHeight: '100vh', backgroundColor: '#f7f5f3' }}>
      <style>{`
        #hubspot-request-form .hs-form { max-width: 100%; }
        #hubspot-request-form .hs-form input,
        #hubspot-request-form .hs-form textarea,
        #hubspot-request-form .hs-form select {
          width: 100% !important;
          box-sizing: border-box;
        }
        #hubspot-request-form .hs-form .hs-submit input {
          background-color: #385cbc !important;
          border: none !important;
          border-radius: 30px !important;
          padding: 14px 32px !important;
          font-size: 16px !important;
          font-weight: 600 !important;
          cursor: pointer !important;
          transition: opacity 0.2s !important;
        }
        #hubspot-request-form .hs-form .hs-submit input:hover {
          opacity: 0.9 !important;
        }
      `}</style>

      <div style={{ padding: '120px 24px 80px', maxWidth: '640px', margin: '0 auto' }}>
        <button
          onClick={onBack}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            fontSize: '15px',
            color: '#385cbc',
            fontWeight: '600',
            padding: '0',
            marginBottom: '40px',
            display: 'inline-block'
          }}
        >
          &larr; Back
        </button>

        <div
          id="hubspot-request-form"
          ref={formRef}
          style={{
            backgroundColor: '#fff',
            borderRadius: '12px',
            padding: '32px',
            boxShadow: '0 2px 12px rgba(0,0,0,0.06)'
          }}
        />
      </div>
    </div>
  );
};
